import WafflesButton from '@datacamp/waffles-button';
import { SparklesIcon } from '@datacamp/waffles-icons';
import React, { useCallback } from 'react';
import { unreachableWithReturn } from '../../unreachable';
import { useTranslation } from '../../useTranslation'; // @ts-expect-error open-ai.svg cannot be found

import OpenAILogo from './open-ai.svg';
import { jsx as ___EmotionJSX } from "@emotion/react";

var getButtonTrackId = function getButtonTrackId(messageType) {
  switch (messageType) {
    case 'ASSISTANT':
      return 'campus-app-fix-error-ai-assistant-button';

    case 'INCORRECT':
      return 'campus-app-ai-incorrect-submission-button';
    // these message types should not have an AI button

    case 'HINT':
    case 'CORRECT':
    case 'SOLUTION':
      return '';

    default:
      return unreachableWithReturn(messageType, '');
  }
};

var Button = function Button(_ref) {
  var loading = _ref.loading,
      messageType = _ref.messageType,
      onClick = _ref.onClick;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var getButtonText = useCallback(function () {
    switch (messageType) {
      case 'ASSISTANT':
        return t('AiAssistantButton.assistantButton');

      case 'HINT':
      case 'INCORRECT':
        return t('AiAssistantButton.hintButton');

      case 'CORRECT':
      case 'SOLUTION':
        return '';

      default:
        return unreachableWithReturn(messageType, '');
    }
  }, [t, messageType]);
  var buttonText = getButtonText();
  var buttonTrackId = getButtonTrackId(messageType);
  var isEnabled = messageType === 'ASSISTANT' || messageType === 'INCORRECT';

  if (!isEnabled) {
    return null;
  }

  return ___EmotionJSX("div", {
    className: "dc-assistant__button",
    "data-trackid": buttonTrackId
  }, ___EmotionJSX(WafflesButton, {
    loading: loading,
    onClick: onClick
  }, ___EmotionJSX(SparklesIcon, null), buttonText), ___EmotionJSX("div", {
    className: "dc-assistant__powered"
  }, ___EmotionJSX("span", {
    className: "dc-assistant__span"
  }, t('AiAssistantButton.poweredBy'), ' '), ___EmotionJSX("img", {
    alt: "OpenAI Logo",
    className: "dc-assistant__svg",
    src: OpenAILogo
  })));
};

export default Button;